var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("v-data-table", {
        staticClass: "elevation-1",
        attrs: {
          headers: _vm.headers,
          items: _vm.projects_list,
          "item-value": "id",
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function () {
              return [
                _c(
                  "v-toolbar",
                  { attrs: { flat: "" } },
                  [
                    _c("v-toolbar-title", [_vm._v("Projects")]),
                    _c(
                      "a",
                      {
                        staticClass: "mx-4",
                        attrs: { href: "/#/pages/research/new-projects" },
                      },
                      [
                        _c("v-btn", { attrs: { small: "" } }, [
                          _vm._v("Create new"),
                        ]),
                      ],
                      1
                    ),
                    _c("v-spacer"),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "item.gads_client_id",
            fn: function ({ item }) {
              return [
                _c("span", [
                  _vm._v(
                    _vm._s(item.gads_client_id ? item.gads_client_id : "N/A")
                  ),
                ]),
              ]
            },
          },
          {
            key: "item.name",
            fn: function ({ item }) {
              return [
                _c(
                  "a",
                  { attrs: { href: `#/pages/projects/${item.id}/clusters` } },
                  [_vm._v(_vm._s(item.name))]
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }